/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import VueRecaptcha from 'vue-recaptcha';

/**
 * Google recaptcha mixin provides functionality for verifiable requests.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    components: {
        'c-vue-recaptcha': VueRecaptcha,
    },
})
export default class Captcha extends Vue {
    public captchaResponse: string | boolean = false;

    /**
     * Google captcha site-key.
     * @return {string}
     */
    get siteKey(): string {
        return process.env.VUE_APP_GOOGLE_CAPTCHA_KEY || '';
    }

    /**
     * Reload recaptcha.
     */
    public reloadRecaptcha(): void {
        try {
            if (!document.body.classList.contains('recaptcha-loaded')) {
                const node: HTMLScriptElement = document.createElement('script');
                node.setAttribute('src',
                    'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
                document.head.appendChild(node);
                document.body.classList.add('recaptcha-loaded');
            }
        } catch (e) {
            // do nothing
        }
    }

    /**
     * Token expiry listener.
     */
    public onExpired(): void {
        (this.$refs.recaptcha as VueRecaptcha).reset();
    }

    /**
     *  Progress to the next step if form values are valid.
     * @return {Promise<void>}
     */
    public async submit(): Promise<void> {
        // Submit issue via recaptcha
        await this.reset();
        (this.$refs.recaptcha as VueRecaptcha).execute();
    }

    /**
     * Overridable function that should be used to process verifiable request.
     * @param {string} token
     * @return {Promise<void>}
     */
    public async onVerify(token: string): Promise<void> {
        this.captchaResponse = token;
    }

    /**
     * Reset the recaptcha plugin.
     * @return {Promise<void>}
     */
    public async reset(): Promise<void> {
        (this.$refs.recaptcha as VueRecaptcha).reset();
    }
}

